import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoginBySessionComponent } from './components/login-by-session/login-by-session.component';
import { LoginComponent } from './components/login/login.component';
import { CodeVerificationComponent } from 'shared/src/public-api';

@NgModule({
  imports: [RouterModule.forChild([
    { path: '', component: LoginComponent, },
    { path: 'token/:token', component: LoginComponent, },
    { path: ':sessionId', component: LoginBySessionComponent },
    {
      path: 'loginVerfication', component: CodeVerificationComponent,
      //data: { certificateType: CertificateType.ShippingCertificate }
    }
  ])
  ],
  exports: [RouterModule]
})
export class LoginRoutingModule { }
